<template lang="pug">
  v-tiptap-editor(
    v-bind="{ ...$attrs, extensions }"
    v-on="$listeners"
  )
    template(v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope")
      slot(:name="slot" v-bind="scope")
    template(v-for="(_, name) of $slots" :slot="name")
      slot(:name="name")
</template>

<script>
import VTiptapEditor, {
  History,
  Bold,
  Underline,
  Heading,
  Italic,
  TextAlign,
  Link,
  ListItem,
  BulletList,
  OrderedList,
  BubbleMenu,
} from 'v-tiptap-editor';

export default {
  components: {
    VTiptapEditor,
  },
  data() {
    return {
      extensions: [
        BubbleMenu,
        History,
        Bold,
        Underline,
        Italic,
        Heading,
        TextAlign,
        Link,
        ListItem,
        BulletList,
        OrderedList,
      ],
    };
  },
};
</script>
